"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncModule = void 0;
const inversify_1 = require("inversify");
const io = require("socket.io-client");
const guid_1 = require("../../util/guid");
let SyncModule = class SyncModule {
    constructor() {
        this.connections = new Map();
    }
    /**
     * set socket connection url
     *
     * @param {string} url
     */
    setUrl(url) {
        // connect to url
        this.socket = io.connect(url + "data-sync", {
            transports: ["websocket"],
            upgrade: false
        });
        // resubscribe to event scopes on socket reconnect
        this.socket.on("reconnect", () => {
            if (!this.sessionToken) {
                // no session active, just configure
                this.reconnectAll();
                return;
            }
            // re-authenticate
            this.socket.emit("sync_authenticate", this.sessionToken, () => 
            // authenticate before configuring
            this.reconnectAll());
        });
        // configure when we start
        this.configureSocket();
    }
    /**
     * get session token
     *
     * @returns {string}
     */
    get sessionToken() {
        return this._sessionToken;
    }
    /**
     * set session token
     *
     * @param {string | null} newSessionToken
     */
    set sessionToken(newSessionToken) {
        // if the tokens are the same, do nothing
        if (newSessionToken === this._sessionToken) {
            return;
        }
        // set the session token to the new
        this._sessionToken = newSessionToken;
        // authenticate, this will automatically re-create all endpoints on the server
        // using the new session (allows for user switching)
        this.socket.emit("sync_authenticate", newSessionToken);
    }
    reconnectAll() {
        // reconnect to everything (if server dropped out we want to seamlessly re-connect to all endpoints)
        for (const connectionGuid of this.connections.keys()) {
            const connection = this.connections.get(connectionGuid);
            this.socket.emit("sync_connect", connectionGuid, connection.syncMetadata);
        }
    }
    configureSocket() {
        // subscribe for data events from server
        this.socket.on("sync_data", (guid, newData) => {
            // load local callback for this guid
            const connection = this.connections.get(guid);
            if (connection === undefined) {
                console.warn("Received data for non-existent connection: " + guid);
                return;
            }
            connection.cb(newData);
        });
        // only really used for debugging, shows server errors in the client console
        this.socket.on("sync_connect_error", (guid, error) => {
            // load local callback for this guid
            const connection = this.connections.get(guid);
            if (connection === undefined) {
                console.warn("Received error for non-existent connection: " + guid);
                return;
            }
            connection.cb(new Error(error));
        });
    }
    connect(syncMetadata, cb) {
        // create a guid for this connection
        const guid = (0, guid_1.createGuid)();
        // connect to websocket
        // prefix methods with "sync_" to avoid ambiguity with socket.io native events
        this.socket.emit("sync_connect", guid, syncMetadata);
        // store connection
        // we also store "syncMetadata" so we can re-connect if the server drops out
        this.connections.set(guid, { syncMetadata, cb });
        // return guid for future disconnection
        return guid;
    }
    disconnect(guid) {
        // prefix methods with "sync_" to avoid ambiguity with socket.io native events
        // this doesn't disconnect the whole socket, just the endpoint with this guid
        this.socket.emit("sync_disconnect", guid);
        this.connections.delete(guid);
    }
};
SyncModule = __decorate([
    (0, inversify_1.injectable)()
], SyncModule);
exports.SyncModule = SyncModule;
//# sourceMappingURL=SyncModule.js.map